import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { BoardSearchSimplePickerPanel } from '../../board/board-search-filters/BoardSearchSimplePickerPanel';
import { BoardSearchPickerShell } from '../../board/board-search-filters/boardSearchPickerShell';
import {
  buildEcFilterPopoverStyle,
  EC_FILTER_POPOVER_CLASS,
  useEcFilterPopoverLayout,
} from '../../experiencia-cliente/components/experienciaClienteFilterPopoverUtils';
import { TIPO_OS_FIELDS, normOsFlag } from './defeitosVerveTableUi';
import '../../board/board-search-filters/BoardSearchFilters.css';

export function Dv2TipoOsInlinePicker({ open, anchorRef, row, api, onClose }) {
  const layout = useEcFilterPopoverLayout(anchorRef, open, 198, 260);
  const { onTipoOsToggle } = api;
  const cod = String(row.TB01048_CODIGO).trim();

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => {
      const pop = document.querySelector(`[data-dv2-tipo-popover="${cod}"]`);
      if (pop?.contains(e.target) || anchorRef.current?.contains(e.target)) return;
      onClose();
    };
    document.addEventListener('mousedown', onDoc, true);
    return () => document.removeEventListener('mousedown', onDoc, true);
  }, [open, cod, anchorRef, onClose]);

  if (!open || !layout) return null;

  const selectedKeys = TIPO_OS_FIELDS.filter((f) => normOsFlag(row[f.db]) === 1).map((f) => f.db);
  const popoverStyle = buildEcFilterPopoverStyle(layout);

  return ReactDOM.createPortal(
    <div
      data-dv2-tipo-popover={cod}
      className={`${EC_FILTER_POPOVER_CLASS} dv2-tipo-inline-popover`}
      style={popoverStyle}
      role="dialog"
      aria-label="Tipos de OS"
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <BoardSearchPickerShell>
        <BoardSearchSimplePickerPanel
          showSearch={false}
          searchPlaceholder=""
          searchTerm=""
          onSearchChange={() => {}}
          items={TIPO_OS_FIELDS}
          getKey={(item) => item.db}
          getLabel={(item) => item.label}
          selectedKeys={selectedKeys}
          onToggle={(item) => {
            const isOn = normOsFlag(row[item.db]) === 1;
            onTipoOsToggle(row, item, !isOn);
          }}
          emptyMessage="Nenhum tipo"
          listAriaLabel="Tipos de OS"
        />
      </BoardSearchPickerShell>
    </div>,
    document.body
  );
}
